// Indice

import React from 'react';
import { createRoot } from 'react-dom/client';
import { UserProvider } from './UserContext'; 
import { PageProvider } from './PageContext'; 
import App from './App';
import './App.css';
import 'leaflet/dist/leaflet.css';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <UserProvider>
    <PageProvider>
      <App />
    </PageProvider>
  </UserProvider>
);